import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { CommonUIResourcesPackage } from "../common/resources/CommonUIResourcesPackage";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { RetryView } from "./views/RetryView";
import { Localization } from "../common/Localization";
import { AudioManager } from "../../audio/AudioManager";

@injectable()
export class RetryScene extends Viewable<boolean> {
    public constructor(
        private readonly commonUIResources: CommonUIResourcesPackage,
        private readonly localization: Localization,
        @inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler,
        private readonly audioManager: AudioManager 
    ) {
        super();
    }

    @initializer()
    public async initialize(): Promise<void> {
        const sceneCanBeClosed = new PromiseCompletionSource<boolean>();
        this.view = new RetryView(
            this.canvasScaler,
            this.commonUIResources,
            this.localization,
            this.audioManager,
            sceneCanBeClosed
        );
        sceneCanBeClosed.result.then((result) => {
            this.operationControls.complete(result);
        });
    }
}